/** Email Repurpose: enforce Subject / Preview prefixes when the model omits them. */
export function formatRepurposeEmailDisplay(content: string): string {
  const t = content.trim();
  if (!t) return t;
  if (/^\s*Subject:/im.test(t) && /^\s*Preview:/im.test(t)) return t;
  try {
    const j = JSON.parse(t) as { subject?: unknown; preview?: unknown; body?: unknown };
    if (j && typeof j.subject === "string") {
      const preview = typeof j.preview === "string" ? j.preview : "";
      const body = typeof j.body === "string" ? j.body : "";
      return `Subject: ${j.subject}\nPreview: ${preview}\n\n${body}`.trim();
    }
  } catch {
    /* not JSON */
  }
  return t;
}
